export default __webpack_public_path__ + "fonts/cp_bg1.3c98cccc5eed9a389da4295fc90f96e7.png";